module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-toolbar p-component mb-4"
  }, [_c('crmClinetDetailDialog', {
    ref: "openDialog"
  })], 1), _vm._v(" "), _c('DataTable', {
    ref: "po",
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.crmClientLists,
      "paginator": true,
      "rows": 8,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('Button', {
          attrs: {
            "icon": "pi pi-external-link",
            "label": "Export"
          },
          on: {
            "click": function($event) {
              return _vm.exportCSV($event)
            }
          }
        })], 1)]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('Column', {
    attrs: {
      "header": "S.n"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n     " + _vm._s(slotProps.index + 1) + "\n     ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Client Name",
      "field": "clientName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['clientName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'clientName', $$v)
            },
            expression: "filters['clientName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Address",
      "field": "address",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['address']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'address', $$v)
            },
            expression: "filters['address']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Contact Number",
      "field": "primaryContactNumber",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['primaryContactNumber']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'primaryContactNumber', $$v)
            },
            expression: "filters['primaryContactNumber']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Secondary Contact",
      "field": "secondaryContactNumber",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['secondaryContactNumber']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'secondaryContactNumber', $$v)
            },
            expression: "filters['secondaryContactNumber']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Email",
      "field": "email",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['email']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'email', $$v)
            },
            expression: "filters['email']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "sortable": true,
      "header": "Status",
      "field": "status",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['status']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'status', $$v)
            },
            expression: "filters['status']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action",
      "headerStyle": "width: 11em"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editClient(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-danger p-button-sm",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('Dialog', {
    on: {
      "cancel": _vm.cancel,
      "deleted": _vm.deleteCrmClient
    },
    model: {
      value: (_vm.dialogShow),
      callback: function($$v) {
        _vm.dialogShow = $$v
      },
      expression: "dialogShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4245bbba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/crm/crmClientDetails.vue
// module id = 2180
// module chunks = 0